import {makeReactContext} from 'lib/makeReactContext';

/**
 * Tells descendants that they are being rendered inside a button group and whether that group is configured
 * to render at full width. This is used to determine button styling.
 */

interface ButtonGroupContextInterface {
  inFullWidthButtonGroup: boolean;
}

const ButtonGroupContext = makeReactContext<ButtonGroupContextInterface>(
  () => ({
    inFullWidthButtonGroup: false,
  }),
  'ButtonGroupContext'
);

export default ButtonGroupContext;
